import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesConversionRateVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesConversionRateVillagePages;
